
import SparkrunRecipesTable from '@/components/sparkrun/SparkrunRecipesTable.vue'
export default {
  name: 'sparkrunRecipes',
  components: { SparkrunRecipesTable }
}
